import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import jwtDecode from 'jwt-decode';
import usePolling from '../../polling';
import { logout, purgeMessages } from '@plone/volto/actions';
import Cookies from 'universal-cookie';

// XXX: Attualmente implementa il polling per il logout automatico
//      Il Single Sign On è per ora implementato con un cgi esterno
//      https://drive.google.com/drive/folders/1rcG1xmbpl34KM_epzuihne7UcEZEsU1L
const SSO = ({ checkssoUrl }) => {
  const dispatch = useDispatch();
  const token = useSelector((state) => state.userSession.token, shallowEqual);
  const user = useSelector((state) => state.users.user);
  const userId = token ? jwtDecode(token).sub : '';

  // TEST: if (userId && user?.roles && user.roles.includes('Manager')) {
  // TODO: al momento i cittadini sono utenti senza ruoli, in futuro
  //       potrebbero avere ruolo 'Citizen'
  // TODO: useMemo qui potrebbe non servire, la funzione è semplice
  const citizenAuthenticated = useMemo(() => {
    // debug locale con -- return userId;
    return (
      userId &&
      user?.roles &&
      (user.roles.length === 0 || user.roles.includes('Citizen'))
    );
  }, [userId, user]);

  const [isPolling, startPolling, stopPolling] = usePolling({
    url: checkssoUrl,
    interval: 3000,
    // valutare retryCount > 0
    retryCount: 0,
    onSuccess: (data) => {
      if (data?.token) {
        // questa funzione non è mutable e non vede il cambio di stato e neanche
        // i dati cambiati sullo store redux.
        // proviamo leggendo i cookies
        const cookies = new Cookies();
        // console.log('>>> Success', userId, data);
        // console.log('>>> cookies:', cookies.getAll());
        // if (citizenAuthenticated) {
        if (cookies.get('auth_token')) {
          return true;
        } else {
          // console.log('>>> logged out stop polling:');
          return false;
        }
      } else {
        // XXX: questo per uso futuro, al momento l'idp torna un
        //      400, 401 o un CORS error se l'utente non è autenticato
        // console.log('>>>> Error:', userId, data);
        // console.log('>>> logout:', user);
        dispatch(logout());
        dispatch(purgeMessages());
        return false;
      }
    },
    onFailure: (error) => {
      // se l'utente non è autenticato il servizio ritorna un 400, 401 o un CORS error
      // console.error('>>>> Error:', userId, error);
      // console.log('>>> logout:', user);
      dispatch(logout());
      dispatch(purgeMessages());
      stopPolling();
    },
    // fetch options: https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch
    // - include cookies
    credentials: 'include',
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    // se i dati non sono corretti torna un 400 o un CORS error
    // valutare se spostare nei parametri del componente o in config
    body: new URLSearchParams({
      idCliente: '011015',
      urlRed: 'https://www.comune.laspezia.it',
    }),
  });

  useEffect(() => {
    if (citizenAuthenticated) {
      // console.log('start polling => ', user);
      // !isPolling &&  // non serve il controllo è già fatto dentro usePolling
      startPolling();
    } else {
      // console.log('User not found => stop polling');
      // isPolling && // non serve il controllo è già fatto dentro usePolling
      stopPolling();
    }
  }, [user]);

  useEffect(() => {
    return () => {
      // console.log('Cleaned up! => stop polling');
      // isPolling &&  // non serve il controllo è già fatto dentro usePolling
      stopPolling();
    };
  }, []);

  return null;
};

export default SSO;
